<script>
</script>

<div class="container">
    <div class="title">404</div>
    <div class="subtitle">Oops! It's seems we can't find what you requested.</div>
</div>
  
<style>
	.container {
        width: 100%;
        margin: 30px;
        position: relative;
        flex: 1 1 200px;
        display: flex;
        flex-flow: column nowrap;
        align-items: center;
        align-content: center;
        justify-content: center;
	}

    .title {
        font-size: 120px;
        font-weight: 200;
    }

    .subtitle {
        margin-top: 50px;
        font-size: 20px;
    }
</style>